import _ from "lodash";
import { FEEDERLISTS, LABOR } from "../_constants/actionConstants";

const initialState = {
  projLaborLists: {}, // Normalized by projectId
  openLaborDetails: {}, // Normalized by projectId then laborId
  projLaborCrewLists: {}, // Normalized by projectId
  openLaborCrewDetails: {}, // Normalized by projectId, then by laborCrewId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
  error: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LABOR.FETCH_ALL:
    case LABOR.ADD_TO_PROJECT:
    case LABOR.DOWNLOAD_ALL:
    case LABOR.DOWNLOAD_ALL_FULFILLED:
    case LABOR.DELETE:
    case LABOR.EDIT:
    case LABOR.EDIT_PROJECT_LABOR:
    case LABOR.FETCH_ALL:
    case LABOR.FETCH_ALL_FOR_PROJECT:
    case LABOR.FETCH_DETAILS:
    case LABOR.GENERIC_REQUEST:
      return { ...state, fetching: true };

    case LABOR.GENERIC_REQUEST_FULFILLED:
    case LABOR.GENERIC_REQUEST_REJECTED:
      return { ...state, fetching: false };

    case LABOR.FETCH_DETAILS_FULFILLED: {
      const { projectId, laborId, payload } = action;
      if (!projectId || !laborId || !payload) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openLaborDetails: {
          ...state.openLaborDetails,
          [projectId]: { ...state.openLaborDetails[projectId], [laborId]: payload },
        },
      };
    }

    case LABOR.CLEAR_DETAILS: {
      const { projectId, laborId } = action;

      // Return if the details are not currently shown
      if (
        !projectId ||
        !laborId ||
        !(projectId in state.openLaborDetails) ||
        !(laborId in state.openLaborDetails[projectId])
      )
        return { ...state, fetching: false };

      // Details exist, proceed to delete
      let openLaborDetails = _.cloneDeep(state.openLaborDetails);
      delete openLaborDetails[projectId][laborId];

      return { ...state, openLaborDetails, fetching: false };
    }

    case LABOR.ADD_FULFILLED:
    case LABOR.ADD_TO_PROJECT_FULFILLED:
    case LABOR.DELETE_FULFILLED: // Also called in laborCrews reducer, to update projLaborCrewList
    case LABOR.FETCH_ALL_FOR_PROJECT_FULFILLED:
    case LABOR.VERIFY_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projLaborList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projLaborLists: {
          ...state.projLaborLists,
          [projectId]: projLaborList || state.projLaborLists[projectId] || [],
        },
      };
    }

    case LABOR.EDIT_FULFILLED: {
      const { projectId, laborId, projLaborList, laborDetails } = action;
      if (!projectId || !laborId || !projLaborList || !laborDetails)
        return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projLaborLists: {
          ...state.projLaborLists,
          [projectId]: projLaborList,
        },
        openLaborDetails: {
          ...state.openLaborDetails,
          [projectId]: { ...state.openLaborDetails[projectId], [laborId]: laborDetails },
        },
      };
    }

    default:
      return state;
  }
};
